import React, { useEffect, useState } from "react";

import i18next from 'i18next'
import { authAxios } from "../config/config";
import { toast } from "react-toastify";
import IsLoadingHOC from "../Common/IsLoadingHOC";
import {
  BudgetFormat,
  getFormatedDate,
  setReportFormatDate,
  showLimitedText,
} from "../Helper/helper";
import { Link } from "react-router-dom";
import { FaChevronDown, FaEye } from "react-icons/fa";
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import {
  ArchiveBoxXMarkIcon,
  ChevronDownIcon,
  PencilIcon,
  Square2StackIcon,
  TrashIcon,
} from '@heroicons/react/16/solid'
import { IoMdMore } from "react-icons/io";
import Pagination from "../Common/Pagination";
import { useSelector } from "react-redux";
import DeleteConfirmationModel from "./Models/DeleteConfirmationModel";
import { FiPlus } from "react-icons/fi";
import AddBlogModel from "./Models/AddBlogModel";
import AddNewsModel from "./Models/AddNewsModel";
import { useTranslation } from "react-i18next";
import IsLoggedinHOC from "../Common/IsLoggedInHOC";

const News = (props) => {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  const { setLoading } = props;
  const [data, setdata] = useState([])
  const [currentPage, setcurrentPage] = useState(1);
  const [postsPerPage, setpostsPerPage] = useState(5);
  const [totalPosts, settotalPosts] = useState(5);

  const [allmodel, setallmodel] = useState({
    data: [],
    showdeletemodel: false,
    showBlogmodel: false,
  })

  const paginate = (pageNumber) => setcurrentPage(pageNumber);
  const [activeActionDropdown, setActiveActionDropdown] = useState("");
  const currentlanguage = i18next.language
  const fetchAllData = async () => {
    setLoading(true);
    try {
      const response = await authAxios().get(
        `/admin/news?page=${currentPage}&limit=${postsPerPage}`
      );
      setLoading(false);
      const resData = response?.data;
      console.log(resData)
      setdata(resData.data.news)
      settotalPosts(resData.data.totalNews)
    } catch (error) {
      setLoading(false);
      toast.error(error?.response?.data?.message);
    }
  }


  const handleCancel = () => {
    setallmodel((prev) => ({
      ...prev,
      data: [],
      showdeletemodel: false,
      showBlogmodel: false,
    }))
  }

  const handleDelete = async () => {
    await authAxios()

      .delete(`/admin/news/${allmodel.data._id}`)
      .then((response) => {

        handleCancel()
        toast.success(response.data.message)
        fetchAllData()

      }).catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      })
  }


  const handleAdd = async (data) => {
    const payload = data
    await authAxios()
      .post(`/admin/news`, payload)
      .then((response) => {
        console.log("res", response)
        fetchAllData()
        handleCancel()
      }).catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      })
  }


  const handleUpdate = async (data) => {
    const payload = data
    await authAxios()
      .put(`/admin/news/${allmodel?.data?._id}`, payload)
      .then((response) => {
        console.log("res", response)
        fetchAllData()
        handleCancel()
      }).catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      })
  }



  useEffect(() => {
    fetchAllData()
  }, [currentPage])



  return (
    <>
      <div className="px-[50px] py-[20px] bg-lightgray area--page pb-0">
        <div className="w-[100%] mx-auto pb-[65px]">
          <div className="flex mb-[30px] gap-[20px] items-center">
            {/* <h1 className="text-[clamp(20px,2vw,35px)] leading-none font-semibold">
              All Jobs
            </h1> */}
          </div>

          <div className="flex mb-[30px] gap-[20px] gap-y-[10px] md:items-center w-full md:justify-between md:flex-row flex-col-reverse ">
            {/* <div className="filter--search flex">
                     <div className="filter--input--search flex items-center bg-white pl-[15px] rounded-[5px] h-[45px] min-h border border-bordergray">
                       <img
                         src="/assets/images/search-icon.svg"
                         className="mr-[5px] search--icon"
                       />
                       <input
                         type="text"
                         placeholder="Search here"
                        // value={searchKeywords}
                         className="input--text"
                        // onChange={(e) => handleSearch(e.target.value)}
                       />
                     </div>
                   </div>
          */}
            <div className="flex gap-[5px] gap-y-[10px] flex-wrap w-full justify-end">
              <button className="flex items-center max-w-[140px] border border-white w-full justify-center bg-white text-textcolor py-[8px] px-[10px]  rounded-[5px] duration-[0.3s] hover:bg-transparent hover:border-textcolor hover:text-textcolor h-[45px] font-[600] min-h">
                Total : {totalPosts || 0}
              </button>

              <button
                onClick={() => setallmodel((prev) => ({
                  ...prev,
                  data: [],
                  showBlogmodel: true
                }))}
                className="flex items-center max-w-[160px] border border-buttonbg w-full justify-center bg-buttonbg text-white py-[8px] px-[15px]  rounded-[5px] duration-[0.3s] hover:bg-transparent hover:text-textcolor h-[45px] font-[600] min-h"
              >
                <FiPlus />
                Add
              </button>
            </div>
          </div>

          <div className="relative mt-[10px] overflow-x-auto px-[20px] py-[15px] bg-white rounded-t-[10px] h-[100vh] over--scroller area--table">
            <table className="w-full text-sm text-left text-gray-500 ">
              <thead className="text-xs text-lightcolor border-b border-textcolor">
                <tr>
                  <th className="p-4 font-[400]">S.no</th>
                  <th className="p-4 font-[400]"> Image</th>
                  <th className="p-4 font-[400]">Title</th>
                  <th className="p-4 font-[400]">Content</th>
                  <th className="p-4 font-[400] min-w-[150px]">Category </th>
                  <th className="p-4 font-[400] min-w-[150px]">Tags </th>
                  <th className="p-4 font-[400] min-w-[150px]">Created At</th>

                  <th className="p-2 font-[400] w-[50px]">Actions</th>
                </tr>
              </thead>
              <tbody>
                {data &&
                  data.map((item, index) => (
                    <tr
                      key={index}
                      className="bg-white border-b hover:bg-gray-50"
                    >
                      <td className="px-5 py-5 border-b border-gray-200 text-sm max-w-[80px]">
                        <p className="whitespace-no-wrap text-textcolor">
                          {index + 1}
                        </p>
                      </td>
                      <td className="px-5 py-5 border-b border-gray-200 text-sm max-w-[200px]">
                        <div className="flex items-center">
                          <div className="flex-shrink-0 w-10 h-10">
                            <img
                              className="w-full h-full rounded-full"
                              src={`${process.env.REACT_APP_IMAGE_URL}/${item?.coverImage}`}
                            // src={item?.coverImage}
                            />
                          </div>
                          <div className="ml-3 overflow-hidden">
                            {/* <p className="text-gray-900 whitespace-no-wrap">
                              {item.title?.currentlanguage}
                            </p> */}
                          </div>
                        </div>
                      </td>
                      <td className="px-5 py-5 border-b border-gray-200 text-sm max-w-[200px]">
                        <p className="text-gray-900 whitespace-no-wrap">
                          {/* {currentlanguage} */}
                          {item?.title[currentlanguage]}
                        </p>
                      </td>
                      <td className="px-5 py-5 border-b border-gray-200 text-sm max-w-[200px]">
                        <div class='has-tooltip'>
                          <span class='tooltip rounded shadow-lg p-1 bg-gray-100 text-black -mt-8'> {item?.content[currentlanguage]}</span>
                          {
                            showLimitedText(item?.content[currentlanguage])
                          }
                        </div>
                      </td>
                      <td className="px-5 py-5 border-b border-gray-200 text-sm max-w-[100px]">
                        <p className="text-gray-900 whitespace-no-wrap">
                          {item?.category[currentlanguage] || "N/A"}
                        </p>
                      </td>
                      <td className="px-5 py-5 border-b border-gray-200 text-sm max-w-[150px]">
                        <p className="text-gray-900 whitespace-no-wrap">
                          {
                            item.tags[currentlanguage].length === 0 ? (
                              <p>N/A</p>
                            ) : (
                              item.tags[currentlanguage].map((newItem, index) => (
                                <p key={index}>{newItem}</p>
                              ))
                            )
                          }
                        </p>
                      </td>
                      <td className="px-5 py-5 border-b border-gray-200 text-sm max-w-[150px]">
                        <p className="text-gray-900 whitespace-no-wrap">
                          {setReportFormatDate(item?.createdAt)}
                        </p>
                      </td>


                      <td className="p-2 border-b border-gray-200 text-sm max-w-[80px]">
                        <Menu as="div" className="relative inline-block text-left">

                          <Menu.Button className="more--icon cursor-pointer w-[30px] h-[30px] bg-lightgray rounded-[5px] flex items-center justify-center">
                            <IoMdMore />
                          </Menu.Button>

                          {/* Menu items */}
                          <Menu.Items className={`absolute ${isRTL ? "left-0" : "right-0"} z-10 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black/5`}>
                            <div onClick={() => setallmodel((prev) => ({
                              ...prev,
                              data: item,
                              showBlogmodel: true
                            }))} className="py-1">
                              <Menu.Item>
                                {({ active }) => (
                                  <a

                                    className={`block px-4 py-2 text-sm ${active ? "bg-gray-100 text-gray-900" : "text-gray-700"
                                      }`}
                                  >
                                    Edit
                                  </a>
                                )}
                              </Menu.Item>
                            </div>

                            <div onClick={() => setallmodel((prev) => ({
                              ...prev,
                              data: item,
                              showdeletemodel: true
                            }))} className="py-1">
                              <Menu.Item>
                                {({ active }) => (
                                  <a

                                    className={`block px-4 py-2 text-sm ${active ? "bg-gray-100 text-gray-900" : "text-gray-700"
                                      }`}
                                  >
                                    Delete
                                  </a>
                                )}
                              </Menu.Item>
                            </div>
                          </Menu.Items>
                        </Menu>
                      </td>

                    </tr>
                  ))}
              </tbody>
            </table>

          </div>
          <Pagination
            currentPage={currentPage}
            totalPosts={totalPosts}
            paginate={paginate}
            postsPerPage={postsPerPage}
            length={data?.length}
          />

          {
            allmodel.showdeletemodel && <DeleteConfirmationModel
              handleCancel={handleCancel}
              handleDelete={handleDelete}
            />
          }

          {
            allmodel.showBlogmodel && <AddNewsModel allmodel={allmodel} handleUpdate={handleUpdate} handleCancel={handleCancel} handleAdd={handleAdd} />
          }
        </div>
      </div>
    </>
  );
};

export default IsLoggedinHOC(IsLoadingHOC(News));
